export default __webpack_public_path__ + "671d5dc83f2e98541832c5b2725c4ee8.png";